import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "block-container",
  style: {"background":"var(--ion-color-background)","display":"flex","flex-direction":"column"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (!_ctx.isNative)
        ? (_openBlock(), _createBlock(_component_back_button, {
            key: 0,
            backBtn: _ctx.isMobile,
            backText: "Back",
            class: "back-btn"
          }, null, 8, ["backBtn"]))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ion_content, { key: 1 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.currentPage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", {
                        innerHTML: _ctx.currentPage.content,
                        ref: "pageRef"
                      }, null, 8, _hoisted_3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Footer)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ion_spinner, {
            key: 2,
            name: "lines-small",
            class: "full-height full-width"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}